<template>
	<div class="container">
		<div style="width: 1200px;margin: 0 auto;">
			<div class="classify-two fl-al">
				<div class="two-one" v-for="(item,index) in courseTypeArr"
					:class="[nowTop == item.courseCategoryName ? 'one_act' : '']" @click="chooseTop(item)">
					{{item.courseCategoryName}}
				</div>
			</div>
			<div class="course-list fl-al">
				<el-empty :description="'暂无相关课程'" v-if="noGood" style="margin: 0 auto;"></el-empty>
				<div class="list-one fl-col" v-for="(item,index) in courseList" @click="toDetail(item)">
					<img :src="item.courseImage" alt="" class="poster" loading="lazy"/>
					<div class="one-info">
						<div class="info-name fl-between-al">
							<div class="name one-line">
								{{item.courseName}}
							</div>
							<div class="process">
								已学习{{item.rateLearn}}%
							</div>
						</div>
						<div class="introd one-line">
							{{item.content}}
						</div>
						<div class="course-time fl-al">
							<div class="time-left">
								课程有效期
							</div>
							<div class="time-right">
								{{item.expireTime ? item.expireTime : '永久有效'}}
							</div>
						</div>
						<div class="course-bottom fl-between-al">
							<div class="teacher-list fl-al">
								<img :src="teacheritem" alt="" v-for="(teacheritem,teacherindex) in item.lecturerImages"
									style="object-fit:contain" />
							</div>
							<div class="continue-btn all-bottom-btn">
								继续听课
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import {
		Toast,
		debounceNew
	} from '@/utils/index';
	import {
		courseListApi,
		courseTypeApi
	} from '@/api/course/course';
	import { wxLoginApi,userInfoApi } from '@/api/user/user';
	import { mapState, mapActions } from 'vuex';
	window.onload = function() {
	    var newUrl = window.location.href.replace(/\?code=.*?&state=#/, '#');
		console.log(newUrl);
	    history.replaceState(null, null, newUrl);
	};
	export default {
		components: {
			// ScrollView,
		},
		data() {
			return {
				nowTop: '全部',
				// courseTypeArr:['sdfd','级系统课程'],
				courseTypeArr: [{
					courseCategoryName: '全部'
				}],
				firstType_id: '', //一级分类id
				pageNo: 1,
				noGood: '',
				pageEnd: '',
				courseList: [],
				loading: false, //加载中
			}
		},
		async created() {
			// eslint-disable-next-line no-undef,no-unused-vars
			let wxcode = window.location.search.substring(6).split('&')[0]
			if(wxcode && !this.$store.state.isLoggedIn){
				await this.weixinLogin(wxcode)
			}
			await this.GetClassType()
			this.pageNo = 1
			if (this.$store.state.isLoggedIn) {
				await this.GetClassTList()
			} else {
				this.noGood = true
			}
			// 在页面加载完成后，移除地址栏中的 code 参数
			
		},
		mounted() {
			// document.title = '卫灿';
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			// 移除滚动事件监听
			window.removeEventListener('scroll', this.handleScroll);
		},
		computed: {
			...mapState(['isLoggedIn']) // 在计算属性中映射用户的登录状态
		},
		watch: {
			isLoggedIn(newValue, oldValue) {
				console.log(newValue);
				// 监听用户的登录状态变化，并根据变化来更新页面渲染
				if (newValue) {
					// 用户已登录，执行相应的操作
					this.GetClassTList()
				} else {
					// 用户已注销，执行相应的操作
					this.courseList = [],
					this.noGood = true
				}
			},
		},
		methods: {
			...mapActions(['login', 'logout']),
			toDetail(item){
				this.$router.push({
					path: 'detail?course=' + item.id + (item.subsectionId ? '&subsectionId=' + item.subsectionId : '') + (item.chapterId ? '&chapterId=' + item.chapterId : '')
				});
			},
			handleScroll() {
				if (!this.$store.state.isLoggedIn) {
					return false
				}
				// 获取页面高度、滚动高度、视窗高度
				const windowHeight = window.innerHeight;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// console.log(windowHeight + '?' + scrollHeight + '?' + scrollTop);
				// 判断是否滚动到底部并且不在加载中
				if (scrollTop + windowHeight >= scrollHeight && !this.loading && !this.pageEnd) {
					console.log(scrollTop);
					this.loading = true
					this.pageNo++
					this.GetClassTList()
				}
			},
			chooseTop(item) {
				if (this.nowTop != item.courseCategoryName) {
					this.nowTop = item.courseCategoryName
					this.firstType_id = item.courseCategoryId
					if (!this.$store.state.isLoggedIn) {
						return false
					}
					this.pageNo = 1
					this.pageEnd = ''
					this.GetClassTList()
				}
			},
			// 获取课程分类
			async GetClassType() {
				let data = null
				await courseTypeApi(data).then(res => {
					console.log(res);
					if (res.code === 200) {
						this.courseTypeArr = res.data
						this.courseTypeArr = [{
							courseCategoryName: '全部',
							courseCategoryId: ''
						}, ...this.courseTypeArr]
					} else {
						Toast(res.msg, 'error')
					}

				})
			},
			// 获取课程列表
			async GetClassTList() {
				let data = {
					courseCategory1: this.firstType_id,
					courseCategory2: '',
					pageNum: this.pageNo,
					pageSize: 20
				}
				await courseListApi(data).then(res => {
					console.log(res.data);
					if (res.code === 200) {
						if (this.pageNo == 1) {
							this.courseList = res.data
						} else {
							this.courseList = [...this.courseList, ...res.data]
						}
						if (res.data.length < data.pageSize) {
							this.pageEnd = true
						} else {
							this.pageEnd = false
						}
						this.courseList.forEach(item => {
							if (item.expireTime) {
								item.expireTime = item.expireTime.slice(0, 10)
							}
						})
						this.noGood = !this.courseList.length
					} else {
						Toast(res.msg, 'error')
					}
					this.loading = false
					console.log(this.courseList);
				})
			},
			// 微信登录
			async weixinLogin(wxCode){
				// axios({  
				//     'url': `https://api.weixin.qq.com/sns/oauth2/access_token?appid=wx0c7c8257de58253a&secret=d700254dc5d6735f0629ca529b467213&code=${wxCode}&grant_type=authorization_code`,
				//     'method': 'get'
				// }).then(async res=>{
				// 	console.log(res);
				// 	const data = await wxLoginApi({
				// 		wxCode:res.openid
				// 	})
				// 	if(data.code == 200){
				// 		localStorage.setItem('token', data.data.token);
				// 		await userInfoApi().then(res=>{
				// 			console.log(res);
				// 			Toast('登录成功')
				// 			const { nickName, phone, userId, avatar } = res.data || {};
				// 			const info = {nickName,phone,userId,avatar}
				// 			localStorage.setItem('userInfo',JSON.stringify(info));
				// 			this.login(info)
				// 			setTimeout(()=>{
				// 				this.loginWay1 = false
				// 			},300)
				// 		})
				// 	}else{
				// 		Toast(data.msg,'error')
				// 	}
				// })
				const data = await wxLoginApi({
					wxCode:wxCode
				})
				if(data.code == 200){
					localStorage.setItem('token', data.data);
					await userInfoApi().then(res=>{
						console.log(res);
						Toast('登录成功')
						const { nickName, phone, userId, avatar } = res.data || {};
						const info = {nickName,phone,userId,avatar}
						localStorage.setItem('userInfo',JSON.stringify(info));
						this.login(info)
						setTimeout(()=>{
							this.loginWay1 = false
						},300)
					})
				}else{
					Toast(data.msg,'error')
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		width: 1320px;
		margin: 0 auto;
		height: fit-content;
		overflow: hidden;
	}

	::-webkit-scrollbar {
		height: 5px;
		overflow: hidden;
		cursor: pointer;
	}

	::-webkit-scrollbar-thumb {
		/* 滚动条滑块圆角 */
		border-radius: 8px;
		/* 滚动条滑块背景色 */
		background: rgba(255, 139, 2, 0.35);
		position: absolute;
		bottom: 0;
	}

	.classify-two:hover {
		overflow: auto;
	}

	.classify-two {
		width: 1200px;
		min-height: 73px;
		background: #FFFFFF;
		border-radius: 113px 113px 113px 113px;
		margin-top: 12px;
		padding-left: 33px;
		flex-wrap: nowrap;
		overflow-x: hidden;
		position: relative;
		box-sizing: border-box;

		.two-one {
			color: #999999;
			text-align: center;
			height: 32px;
			line-height: 32px;
			cursor: pointer;
			margin-right: 20px;
			min-width: 120px;
			flex-shrink: 0;
		}

		.one_act {
			background: linear-gradient( 138deg, #1FED83 0%, #19C76C 100%);
			border-radius: 20px 20px 20px 20px;
			color: #FFFFFF;
		}
	}

	.course-list {
		width: 1200px;
		flex-wrap: wrap;
		margin-top: 20px;
		margin-bottom: 20px;
		// overflow: hidden;
		.list-one:hover {
			cursor: pointer;
			transform: scale(1.03);
		}
		.list-one {
			transition: transform 0.2s ease;
			width: 280px;
			height: 315px;
			border-radius: 16px 16px 8px 8px;
			margin-right: 26px;
			margin-bottom: 16px;
			overflow: hidden;
			background: #FFFFFF;

			.poster {
				width: 280px;
				height: 158px;
				border-radius: 16px;
				background: #D9D9D9;
			}

			

			.one-info {
				padding: 14px 8px;
				box-sizing: border-box;
				// height: 157px;
				background: #FFFFFF;

				.info-name {
					height: 22px;
					font-weight: 500;
					font-size: 16px;
					color: #333333;

					.name {
						max-width: 180px;
					}

					.process {
						font-weight: 400;
						font-size: 12px;
						color: #999999;
					}
				}

				.introd {
					margin-top: 16px;
					max-width: 260px;
					height: 20px;
				}

				.course-time {
					margin-top: 20px;
					font-size: 12px;
					text-align: center;
					line-height: 20px;
					height: 20px;

					.time-left {
						width: 73px;
						height: 20px;
						background: #01BF5C;
						border-radius: 6px 0px 0px 6px;
						color: #FFFFFF;
					}

					.time-right {
						width: 73px;
						height: 20px;
						background: #E5FFE6;
						border-radius: 0px 6px 6px 0px;
						color: #01BF5C;
					}
				}

				.course-bottom {
					margin-top: 8px;
					height: 32px;

					.teacher-list:hover {
						overflow-x: auto;
					}

					.teacher-list {
						width: 160px;
						white-space: nowrap;
						overflow: hidden;

						img {
							flex-shrink: 0;
							width: 24px;
							height: 24px;
							border-radius: 12px 12px 12px 12px;
							margin-right: 8px;
							background-color: #F75967;
						}
					}

					.continue-btn {
						width: 90px;
						height: 32px;
						margin: 0;
						cursor: pointer;
					}
				}
			}
		}

		.list-one:nth-child(4n) {
			margin-right: 0;
		}
	}
</style>